"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalSectionToggledMiddleware = void 0;
const react_1 = __importDefault(require("react"));
const useModalSectionToggledMiddleware = () => {
    const subscriptionsRef = react_1.default.useRef([]);
    const add = react_1.default.useCallback((section, mode, fn) => {
        subscriptionsRef.current.push([section, mode, fn]);
    }, []);
    const remove = react_1.default.useCallback((mode, fn) => {
        subscriptionsRef.current = subscriptionsRef.current.filter((f) => f[2] !== fn && f[1] !== mode);
    }, []);
    const triggerSubscriptions = react_1.default.useCallback((section, mode) => {
        subscriptionsRef.current.forEach(([_section, _mode, fn]) => {
            if (_section === section && mode === _mode) {
                fn();
            }
        });
    }, []);
    return { add, remove, triggerSubscriptions };
};
exports.useModalSectionToggledMiddleware = useModalSectionToggledMiddleware;
